import { Record } from "immutable";

export class ReportingIndustry extends Record({
    id: null,
    name: null
}) {}
